import { createSlice } from "@reduxjs/toolkit";
import {
  GET_DIVISION_GROUP_SUCCESS,
  GET_DIVISION_GROUP_FAIL,
  GET_QUERY_DETAILS_SUCCESS,
  GET_QUERY_DETAILS_FAIL,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_FAIL,
} from "../constants/action-types";

// --- Division Group Slice ---
const divisionGroupSlice = createSlice({
  name: "divisionGroup",
  initialState: { getDivisionGroup: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_DIVISION_GROUP_SUCCESS, (state, { payload }) => {
        state.getDivisionGroup = payload;
      })
      .addCase(GET_DIVISION_GROUP_FAIL, (state) => {
        state.getDivisionGroup = [];
      });
  },
});

// --- Query Details Slice ---
const queryDetailsSlice = createSlice({
  name: "queryDetails",
  initialState: { queryDetails: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_QUERY_DETAILS_SUCCESS, (state, { payload }) => {
        state.queryDetails = payload;
      })
      .addCase(GET_QUERY_DETAILS_FAIL, (state) => {
        state.queryDetails = [];
      });
  },
});

// --- Product Slice ---
const productSlice = createSlice({
  name: "product",
  initialState: { productList: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_PRODUCT_SUCCESS, (state, { payload }) => {
        state.productList = payload;
      })
      .addCase(GET_PRODUCT_FAIL, (state) => {
        state.productList = [];
      });
  },
});

export const getDivisionGroupReducer = divisionGroupSlice.reducer;
export const queryDetailsReducer = queryDetailsSlice.reducer;
export const productReducer = productSlice.reducer;
